export function insertAtCaret(element: HTMLInputElement, str: string, isSettingCursor?: boolean) {
  const { selectionStart, selectionEnd } = element;
  const prevTextValue = element.value;
  const expression = prevTextValue.substring(0, selectionStart) + str + prevTextValue.substring(selectionEnd);

  const before = prevTextValue.substring(0, selectionStart);
  const after = prevTextValue.substring(selectionEnd);

  element.value = before + str + after;

  element.focus();

  if (isSettingCursor) {
    const position = before.length + str.length - 1;

    element.setSelectionRange(position, position);
  }

  return expression;
}
